import { useContext } from 'react';
import { WaitContext } from '@atlassian/react-loosely-lazy/lazy-wait/context';
import useLayoutEffectSAFE from '@jira/platform__app-framework-use-layout-effect-safe/src/useLayoutEffectSafe.tsx';
import { useUFOInteractionContext } from './useUFOInteractionContext.tsx';

const returnTrue = () => true;
export const useHold = (
	name: string | undefined,
	lock: boolean,
	isEnabled: () => boolean = returnTrue,
): void => {
	const interactionContext = useUFOInteractionContext();
	const waitContext = useContext(WaitContext);

	// Runs synchronously, to allow us to identify async items
	useLayoutEffectSAFE(() => {
		if (!lock || !isEnabled()) {
			return;
		}
		// if until context exists means there is a LazyWait parent component
		// we use that value
		const shouldHold = waitContext ? !!waitContext.currentValue() : true;
		if (interactionContext != null && shouldHold) {
			return interactionContext.hold(name);
		}
	}, [interactionContext, name, waitContext, lock, isEnabled]);
};
